import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import ArrowIcon from '../../assets/svgs/ArrowIcon';

import Api from '../../libs/Api';
import translate from '../../libs/i18n';
import { useIsMounted } from '../../utils/useIsMounted';

import Loading from '../../components/Loading/Loading';
import Header from '../../components/Header/Header';

import { WebVisualizerStyle } from './WebVisualizerStyle';

const WebVisualizer = ({ modal }) => {
  const history = useHistory();
  const isMounted = useIsMounted();
  const language = useSelector((state) => state.settings.language);
  const { id } = useParams();


  const [loading, setLoading] = useState(true);
  const [report, setReport] = useState();
  const [viewerUrl, setViewerUrl] = useState('');
  const [errorViewerModal, setErrorViewerModal] = useState(false);

  useEffect(() => {
    (async () => {
      if (id?.length) {
        if (!isMounted()) {
          return;
        }

        setLoading(true);

        const reportResponse = await Api.getReport(id);
        let currentReport = null;

        if (reportResponse?.status === 200 && reportResponse?.data) {
          currentReport = reportResponse?.data;
        }

        if (reportResponse?.status === 404 || !currentReport) {
          history.push('/404-exame');
        } else if (reportResponse?.status === 200 && currentReport) {
          setReport(currentReport);

          try{
            const viewerResponse = await Api.getWebViewer(currentReport.exam?.study_id)
          
            if (viewerResponse?.status === 200 && viewerResponse?.data?.viewer_url) 
            { 
              setViewerUrl(viewerResponse.data.viewer_url);
            } else {
              setErrorViewerModal(true);
            }
          } catch{
            setErrorViewerModal(true);
          }

          setLoading(false);
        }
        
      }
    })();
  }, [history, id, isMounted]);

  return (
    <WebVisualizerStyle>
      {!modal ? (
        <div>
          <Header />
          <div className="back-div">
              <Link to={`/relatorios/${id}`} className="back-link">
                <span className="icon">
                <ArrowIcon />
                </span>
                {translate('back', language)}
              </Link>
          </div>
        </div>
      ) : null}

      {errorViewerModal ?
        <div className={modal ? 'web-visualizer-modal-container' : 'web-visualizer-container'}>
          <div className="alert alert-danger" role="alert">
              {translate('ohifError', language)}
          </div>
        </div> 
      : null}

      {viewerUrl ? (
        <div className={modal ? 'web-visualizer-modal-container' : 'web-visualizer-container'}>
          <iframe
              id="my-iframe"
              title="Visualização do estudo"
              src={viewerUrl}
          />
        </div>
      ): null}
      {loading ? <Loading /> : null}
    </WebVisualizerStyle>
  );
};

WebVisualizer.propTypes = {
  modal: PropTypes.bool,
};

WebVisualizer.defaultProps = {
  modal: false,
};

export default WebVisualizer;
